import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { CorporateService } from "../corporate.service";

@Component({
  selector: "app-corporate-delete-account",
  templateUrl: "./corporate-delete-account.component.html",
  styleUrls: ["./corporate-delete-account.component.css"],
})
export class CorporateDeleteAccountComponent implements OnInit {
  deleteData: any;
  token: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private matDialogRef: MatDialogRef<CorporateDeleteAccountComponent>,
    private services: CorporateService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {
    this.deleteData = data;
  }

  ngOnInit(): void {
    this.token = sessionStorage.getItem("corporate_token");
    if (this.token == null) {
      this.router.navigateByUrl("/");
    }
  }

  backProfile() {
    this.matDialogRef.close();
  }
  deleteAccount() {
    const userType = "inactive";
    this.services
      .accountDelete(userType, this.deleteData, this.token)
      .subscribe(
        (response: any) => {
          if (response.status == 200) {
            this.matDialogRef.close();
            this.router.navigateByUrl("/");
            localStorage.removeItem("corporate_token");
            localStorage.removeItem("corporateProfilePic");
            localStorage.removeItem("corporateUserName");
            localStorage.removeItem("corporate_user_type");
            this.snackBar.open(
              "Your account has been deleted successfully",
              "Success",
              {
                duration: 5000,
              }
            );
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            localStorage.removeItem("corporate_token");
            localStorage.removeItem("corporateProfilePic");
            localStorage.removeItem("corporateUserName");
            localStorage.removeItem("corporate_user_type");
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            localStorage.removeItem("corporate_token");
            localStorage.removeItem("corporateProfilePic");
            localStorage.removeItem("corporateUserName");
            localStorage.removeItem("corporate_user_type");
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
}
